import { makeVar } from '@apollo/client';
import { authUtil } from 'modules/common/layer00';



export const isLoggedInVar = makeVar(authUtil.evaluateInitialIsLoggedIn());
export const isLoggedInUserSuperAdmin = makeVar<'yes' | 'no' | 'notAttempted'>('notAttempted');
export const activeProjectName = makeVar<string>('');

export type IFilterInstallationsVar = {
  isOverDue: boolean;
  isComplete: boolean;
  isUpcoming: boolean;
  isRemaining: boolean;
  freeTextSearch: string | null;
  areaId: string;
  milestoneId: string;
  roomName: string | null;
  installationTypeId: string ;
  isGrouped: boolean;
};

export type IFilterDocumentsVar = {
  freeTextSearch: string | null;
  folderId: string | null;
};



export const initialDocumentsFilter = {
  freeTextSearch: null,
  folderId: null
};

export const filterDocumentsVar = makeVar<IFilterDocumentsVar>({
  ...initialDocumentsFilter
});


export function resetDocumentsFilter(filtersToSet?: Partial<IFilterDocumentsVar>) {
  if (filtersToSet) {
    filterDocumentsVar({
      ...initialDocumentsFilter,
      ...filtersToSet
    });
    return;
  }
  filterDocumentsVar({
    ...initialDocumentsFilter
  });
  return;
}


export const initialInstallationFilter = {
  isOverDue: true,
  isComplete: true,
  isUpcoming: true,
  isRemaining: true,
  freeTextSearch: null,
  milestoneId: '',
  areaId: '',
  roomName: null,
  installationTypeId: '',
  isGrouped: true
};
export const filterInstallationsVar = makeVar<IFilterInstallationsVar>({
  ...initialInstallationFilter
});

export function resetInstallationFilter(filtersToSet?: Partial<IFilterInstallationsVar>) {
  if (filtersToSet) {
    filterInstallationsVar({
      ...initialInstallationFilter,
      ...filtersToSet
    });
    return;
  }
  filterInstallationsVar({
    ...initialInstallationFilter
  });
  return;
}


type IFilterPlansVar = {
  freeTextSearch: string | null;
};

export const initialPlansFilter: IFilterPlansVar = {
  freeTextSearch: null
};

export const filterPlansVar = makeVar<IFilterPlansVar>({
  ...initialPlansFilter
});

// export function resetPlansFilter(filtersToSet?: Partial<IFilterPlansVar>) {
export function resetPlansFilter() {
  filterPlansVar({
    ...initialPlansFilter
  });
}
